<template>
<v-container class="container-terms">
    <v-row>
        <v-col cols="12" sm="12">
    <div>
        <p>
            <strong>TERMS OF SERVICE AGREEMENT</strong>
        </p>
		<p dir="ltr">
    		<strong>LAST REVISION: 18-Sep-2026</strong>
		</p>
        <p>
            PLEASE READ THIS TERMS OF SERVICE AGREEMENT CAREFULLY. BY USING THIS
            WEBSITE OR ORDERING SERVICES FROM THIS WEBSITE YOU AGREE TO BE BOUND
            BY ALL OF THE TERMS AND CONDITIONS OF THIS AGREEMENT.
        </p>
        <p>
            This Terms of Service Agreement (the "Agreement") governs your use
            of this website, EDURACLE.COM and any of its Sub-domains
            (Hereinafter Referred to as the "Website"). Sofos Learning Solutions
            Private Limited, A company incorporated under Companies Act is the
            operator of the Website Eduracle.com. ("Hereinafter Referred to as
            Sofos").
        </p>
        <p>
            This website, EDURACLE.COM and its Sub-domains, provides users with
            the questions and solutions which help them in preparation for
            Competitive Exams. Such solutions may be sold individually or
            through a subscription on the WEBSITE, depending on the institute or
            individual requesting the documents. The WEBSITE may also provide
            additional services in the form of specialized courses to its users.
            The website or its sub-domains provides education institutes
            specialized services wherein the students of that institute avails
            such services. The services of the WEBSITE will hereinafter
            collectively be referred to as "SERVICES." The following provisions
            define the contractual rights and obligations of the operator of the
            WEBSITE, Sofos Learning Solutions Private Limited ("EDURACLE"), and
            the USERS (as hereinafter defined) of the WEBSITE. USER or USERS
            shall be defined as all individuals that access the WEBSITE, whether
            by surfing, reading, viewing, using, and/or purchasing the
            Questions, Solutions and/or subscribing to the services offered on
            the WEBSITE. The home page of the WEBSITE is located at the
            following URL: www.eduracle.com.
        </p>
        <p>
            This Agreement includes, and incorporates by this reference, the
            policies and guidelines referenced below. Sofos reserves the right
            to change or revise the terms and conditions of this Agreement at
            any time by posting any changes or a revised Agreement on this
            Website. Sofos will alert you that changes, or revisions have been
            made by indicating on the top of this Agreement the date it was last
            revised. The changed or revised Agreement will be effective
            immediately after it is posted on this Website. Your use of the
            Website following the posting any such changes or of a revised
            Agreement will constitute your acceptance of any such changes or
            revisions. Sofos encourages you to review this Agreement whenever
            you visit the Website to make sure that you understand the terms and
            conditions governing use of the Website. This Agreement does not
            alter in any way the terms or conditions of any other written
            agreement you may have with Sofos for other products or services. If
            you do not agree to this Agreement (including any referenced
            policies or guidelines), please immediately terminate your use of
            the Website. If you would like to print this Agreement, please click
            the print button on your browser toolbar. The Terms are as per the
            Information Technology Act, 2000 (as amended till date) and is
            generated by a computer system and does not require any physical or
            digital signatures.
        </p>
        <p>
            <strong>Navigation and Access:</strong>
        </p>
        <p>
            The registration on the WEBSITE is free and open to any legal entity
            or natural person, with a valid and active email address. All the
            information provided by the USER must be accurate and each USER can
            open only one account. A USER wishing to register on the WEBSITE
            must choose a password which is strictly confidential and personal.
            It is up to the latter to keep it absolutely secret. Persons who are
            minors, un-discharged insolvents etc. can use our products or
            services under the guidance of legal guardian or parents. As a minor
            if you wish to use our products or services and make payment for
            such services then such use shall be made available to you by your
            legal guardian or parents. Sofos Learning Solutions Private Limited
            will not be responsible for any consequence that arises as a result
            of misuse of any kind of our products or services that may occur by
            virtue of any person including a minor using the services provided.
            By using the products or services you warrant that all the data
            provided by you is accurate and complete and that you have obtained
            the consent of parent/legal guardian (in case of minors). Sofos
            Learning Solutions Private Limited reserves the right to terminate
            your subscription and / or refuse to provide you with access to the
            products or services if it is discovered that you are under the age
            of 18 years and the consent to use the products or services is not
            made by your parent/legal guardian or any information provided by
            you is inaccurate. For any questions or information about the
            Services presented on the WEBSITE or the WEBSITE itself, or to
            report illegal content or activities, or to close its account the
            USER may send an email to: eduracle@gmail.com or written letter to
            Sofos Learning Solutions Private Limited, Cabin No. 23, 2nd Floor,
            West Block, Amanora Mall, Mundhwa–Kharadi Road, Amanora Park Town,
            Pune, Maharashtra – 411028. SOFOS reserves the discretionary right
            to delete a USER account for any reason.
        </p>
        <p>
            <strong>Use of Website:</strong>
            Sofos is not responsible for any damages resulting from use of this
            website by anyone. You will not use the Website for illegal
            purposes. You will (1) abide by all applicable local, state,
            national, and international laws and regulations in your use of the
            Website (including laws regarding intellectual property), (2) not
            interfere with or disrupt the use and enjoyment of the Website by
            other users, (3) not resell material on the Website, (4) not engage,
            directly or indirectly, in transmission of "spam", chain letters,
            junk mail or any other type of unsolicited communication, and (5)
            not defame, harass, abuse, or disrupt other users of the Website
        </p>
        <p>
            <strong>SERVICES</strong>
        </p>
        <p>
            Terms of Offer. This Website offers for sale certain Services. By
            placing an order for Services through this Website, you agree to the
            terms set forth in this Agreement.
        </p>
        <p>
            Customer Solicitation: Unless you notify our third-party call center
            representatives or direct Sofos sales representatives, while they
            are calling you, of your desire to opt out from further direct
            company communications and solicitations, you are agreeing to
            continue to receive further emails and call solicitations from Sofos
            and its designated in house or third party call team(s).
        </p>
        <p>
            Opt Out Procedure: We provide easy ways to opt out from future
            solicitations. You may choose to opt out, via sending your email
            address to: eduracle@gmail.com. or You may send a written remove
            request to Sofos Learning Solutions Private Limited, Cabin No. 23,
            2nd Floor, West Block, Amanora Mall, Mundhwa–Kharadi Road, Amanora
            Park Town, Pune, Maharashtra – 411028.
        </p>
        <p>
            Proprietary Rights: Sofos has proprietary rights and trade secrets
            in the Services. You may not copy, reproduce, resell or redistribute
            any content on the website and/or distributed by Sofos. Sofos also
            has rights to all trademarks and copyrights and specific layouts of
            this webpage, including calls to action, text placement, images and
            other information.
        </p>
        <p>
            Tax: If you purchase any Services, you will be responsible for
            paying any applicable GST or any other tax as levied by Government
            authorities.
        </p>
        <p>
            <strong>WEBSITE</strong>
        </p>
        <p>
            Content; Intellectual Property: In addition to providing services
            available, this Website also offers information and marketing
            materials. This Website also offers information, both directly and
            through indirect links to third-party websites, about competitive
            exams. Sofos creates the information offered on this Website and
            also collects the information from other sources. To the extent that
            Sofos does create the content on this Website, such content is
            protected by intellectual property laws of the India, foreign
            nations, and international bodies. Unauthorized use of the material
            may violate copyright, trademark, and/or other laws. You acknowledge
            that your use of the content on this Website is for personal,
            educational and noncommercial use. Any links to third-party websites
            are provided solely as a convenience to you. Sofos does not endorse
            the contents on any such third-party websites. Sofos is not
            responsible for the content of or any damage that may result from
            your access to or reliance on these third-party websites. If you
            link to third-party websites, you do so at your own risk.
        </p>
        <p>
            <strong>License.</strong>
            By using this Website, you are granted a limited, non-exclusive,
            non-transferable right to use the content and materials on the
            Website in connection with your normal, noncommercial, use of the
            Website. You may not copy, reproduce, transmit, distribute, or
            create derivative works of such content or information without
            express written authorization from Sofos or the applicable third
            party (if third party content is at issue).
        </p>
        <p>
            <strong>Sub-Domains to Educational Institutes:</strong>
            The website provides sub-domains to education institutes whereby the
            institutes uses website’s Online Testing and Analytics platform for
            the benefit of its students. The institute students also get access
            to some services as agreed between the institute and Sofos. The
            institute gives access to personal data of students which Sofos is
            authorized to use for marketing its services.
        </p>
        <p>
            INTELLECTUAL PROPERTY
        </p>
        <p>
            All of the WEBSITE's elements (including ergonomics, texts, graphs,
            images, sounds, videos, programming elements, database - this list
            shall not be considered exhaustive), together or separately, are the
            exclusive property of SOFOS, protected pursuant to the Laws of
            Intellectual Property. Access to the WEBSITE does not represent the
            recognition of a right, and does not confer any rights, including
            any intellectual property rights relating to any of the elements of
            the WEBSITE, which remain SOFOS's exclusive property. Any
            representation, reproduction, adaptation or partial or total
            exploitation of the contents, trademarks, and services provided by
            the WEBSITE by any means whatsoever without the prior express and
            written consent of SOFOS is strictly prohibited and may constitute a
            counterfeiting infringement under the Laws of Intellectual Property.
            The USER is forbidden to enter data on the WEBSITE that would likely
            alter its content or appearance.
        </p>
        <p>
            Take Down Policy: All employees and users of website will comply
            with applicable copyright laws. We respect the legitimate rights of
            copyright owners. If anyone claims of copyright infringement, then
            they should notify Sofos by send an email to: eduracle@gmail.com or
            written letter to Sofos Learning Solutions Private Limited, Cabin
            No. 23, 2nd Floor, West Block, Amanora Mall, Mundhwa–Kharadi Road,
            Amanora Park Town, Pune, Maharashtra – 411028. On receipt of email
            or letter Sofos will do the needful within a reasonable time.
            Further, if Sofos is notified of claimed copyright infringement, or
            otherwise becomes aware of facts and circumstances from which
            infringement is apparent, it will respond expeditiously by removing,
            or disabling access to, the material that is claimed to be
            infringing or to be the subject of infringing activity.
        </p>
        <p>
            DISCLAIMER OF WARRANTIES
        </p>
        <p>
            YOUR USE OF THIS WEBSITE AND/OR SERVICES ARE AT YOUR SOLE RISK. THE
            WEBSITE AND SERVICES ARE OFFERED ON AN "AS IS" AND "AS AVAILABLE"
            BASIS. SOFOS EXPRESSLY DISCLAIMS ALL WARRANTIES OF ANY KIND, WHETHER
            EXPRESS OR IMPLIED, INCLUDING, BUT NOT LIMITED TO, IMPLIED
            WARRANTIES OF FOR A PARTICULAR PURPOSE AND NON-INFRINGEMENT WITH
            RESPECT TO THE SERVICES OR WEBSITE CONTENT, OR ANY RELIANCE UPON OR
            USE OF THE WEBSITE CONTENT OR SERVICES.
        </p>
        <p>
            WITHOUT LIMITING THE GENERALITY OF THE FOREGOING, SOFOS MAKES NO
            WARRANTY:
        </p>
        <ul>
            <li dir="ltr">
                THAT THE INFORMATION PROVIDED ON THIS WEBSITE IS ACCURATE,
                RELIABLE, COMPLETE, OR TIMELY.
            </li>
            <li>
                NO ADVICE OR INFORMATION, WHETHER ORAL OR WRITTEN, OBTAINED BY
                YOU FROM THIS WEBSITE WILL CREATE ANY WARRANTY NOT EXPRESSLY
                STATED HEREIN.
            </li>
            <li>
                AS TO THE RESULTS THAT MAY BE OBTAINED FROM THE USE OF THE
                SERVICES OR THAT DEFECTS IN SERVICES WILL BE CORRECTED.
            </li>
            <li dir="ltr">
                REGARDING ANY SERVICES OR OBTAINED THROUGH THE WEBSITE.
            </li>
        </ul>
        <p>
            LIMITATION OF LIABILITY
        </p>
        <p>
            SOFOS ENTIRE LIABILITY, AND YOUR EXCLUSIVE REMEDY, IN LAW, IN
            EQUITY, OR OTHWERWISE, WITH RESPECT TO THE WEBSITE CONTENT AND
            SERVICES AND/OR FOR ANY BREACH OF THIS AGREEMENT IS SOLELY LIMITED
            TO THE AMOUNT YOU PAID VIA THE WEBSITE.
        </p>
        <p>
            SOFOS WILL NOT BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL,
            SPECIAL OR CONSEQUENTIAL DAMAGES IN CONNECTION WITH THIS AGREEMENT
            OR THE SERVICES IN ANY MANNER, INCLUDING LIABILITIES RESULTING FROM
            (1) THE USE OR THE INABILITY TO USE THE WEBSITE CONTENT OR SERVICES;
            (2) THE COST OF PROCURING SUBSTITUTE SERVICES OR CONTENT; (3) ANY
            SERVICES PURCHASED OR OBTAINED OR TRANSACTIONS ENTERED INTO THROUGH
            THE WEBSITE; OR (4) ANY LOST PROFITS YOU ALLEGE.
        </p>
        <p>
            SOME JURISDICTIONS DO NOT ALLOW THE LIMITATION OR EXCLUSION OF
            LIABILITY FOR INCIDENTAL OR CONSEQUENTIAL DAMAGES SO SOME OF THE
            ABOVE LIMITATIONS MAY NOT APPLY TO YOU.
        </p>
        <p>
            INDEMNIFICATION
        </p>
        <p>
            You will release, indemnify, defend and hold harmless SOFOS, and any
            of its contractors, agents, employees, officers, directors,
            shareholders, affiliates and assigns from all liabilities, claims,
            damages, costs and expenses, including reasonable attorneys' fees
            and expenses, of third parties relating to or arising out of (1)
            this Agreement or the breach of your warranties, representations and
            obligations under this Agreement; (2) the Website content or your
            use of the Website content; (3) the Services or your use of the
            Services (including Trial Services); (4) any intellectual property
            or other proprietary right of any person or entity; (5) your
            violation of any provision of this Agreement; or (6) any information
            or data you supplied to SOFOS. When SOFOS is threatened with suit or
            sued by a third party, SOFOS may seek written assurances from you
            concerning your promise to indemnify SOFOS; your failure to provide
            such assurances may be considered by SOFOS to be a material breach
            of this Agreement. SOFOS will have the right to participate in any
            defense by you of a third-party claim related to your use of any of
            the Website content or Services, with counsel of SOFOS choice at its
            expense. SOFOS will reasonably cooperate in any defense by you of a
            third-party claim at your request and expense. You will have sole
            responsibility to defend SOFOS against any claim, but you must
            receive SOFOS prior written consent regarding any related
            settlement. The terms of this provision will survive any termination
            or cancellation of this Agreement or your use of the Website or
            Services.
        </p>
        <p>
            PRIVACY
        </p>
        <p>
            SOFOS believes strongly in protecting user privacy and providing you
            with notice of SOFOS use of data. Please refer to SOFOS privacy
            policy, incorporated by reference herein, that is posted on the
            Website.
        </p>
        <p>
            PERSONAL DATA
        </p>
        <p>
            SOFOS will securely collect the following personal data when a USER
            purchases a Service:
        </p>
        <p>
            • A proof of purchase for the item selected;
        </p>
        <p>
            • Internal invoices used by SOFOS for tax purposes;
        </p>
        <p>
            • The USER’s email address;
        </p>
        <p>
            • Any Service ordered or saved by the USER.
        </p>
        <p>
            Please note that if a USER selects a Service subscription, SOFOS
            will store information related to the sale with internal accounting
            records. SOFOS collects and stores the personal data that we do so
            that we can continue offering the SERVICES on our WEBSITE.
        </p>
        <p>
            When initially creating a USER account, the following information
            may be collected and stored:
        </p>
        <p>
            • The USER’s first and last name;
        </p>
        <p>
            • The USER’s mailing address.
        </p>
        <p>
            If a USER chooses not to provide this information, access to the
            LIMITED SERVICES offered by SOFOS will still be permitted. The
            information noted above is not required.
        </p>
        <p>
            Personal data collected by SOFOS is exclusively hosted and stored in
            India.
        </p>
        <p>
            No personal data collected by SOFOS is ever shared with any third
            parties. Children who are less than Eighteen years of age are not
            eligible to consent to the processing and the collection of their
            personal data. They should do so under the guidance of their parents
            or legal representative.
        </p>
        <p>
            Cookies
        </p>
        <p>
            SOFOS may use cookies. A cookie is a small file stored on the USER’s
            computer by SOFOS while the USER is using the WEBSITE. Cookies are
            used to improve the browsing experience of the USER. The cookies
            SOFOS uses are “session cookies” and do not require USER consent.
            Cookies used by SOFOS are deleted once the USER closes the browser
            that was used to access the WEBSITE.
        </p>
        <p>
            PRICING
        </p>
        <p>
            Purchase of individual Services: The WEBSITE provides USERS with a
            catalog of Services. Prices and taxes to buy the Services are
            indicated in the catalog. SOFOS reserves the right to change its
            prices at any time by posting them online. The only prices
            applicable to USER transactions are the ones in effect at the time
            the purchase is made.
        </p>
        <p>
            Refund: The services and their charges are expressly mentioned on
            our website. All the payments made to Sofos are non-refundable. If
            there is any technical error while making the payment you can
            contact us on email.
        </p>
        <p>
            PAYMENT
        </p>
        <p>
            Purchase of individual Services: When the USER chooses to buy an
            individual service, the USER makes the payment at the time of the
            final confirmation of the purchase. Upon receipt of confirmation of
            the purchase and payment by the USER, the latter will receive an
            electronic invoice to the email address personally specified within
            a reasonable time.
        </p>
        <p>
            Financial permissions
        </p>
        <p>
            The USER guarantees to SOFOS that the USER has the necessary
            permissions to use the payment method chosen and recognizes that the
            transmission to SOFOS of the USER's banking information is evidence
            of its ability and consent to the sale, and to the payment due
            pursuant to the purchase. SOFOS does not save the details of the
            USER's credit cards, but the proof of the transaction is archived.
            Should the accredited bodies refuse to authorize the payment by
            credit card or in case of non-payment, SOFOS reserves the right to
            suspend or cancel the purchase and its delivery. SOFOS also reserves
            the right to refuse a purchase made by a USER who has not fully paid
            its purchase or has not fully paid a previous purchase or with whom
            a dispute is unsettled.
        </p>
        <p>
            SOFOS is not liable for payment problems related to the operation of
            the SERVICES. The USER acknowledges sole responsibility for any
            problems related to the payment method chosen to access the
            SERVICES.
        </p>
        <p>
            AGREEMENT TO BE BOUND: By using this Website or ordering Services,
            you acknowledge that you have read and agree to be bound by this
            Agreement and all terms and conditions on this Website.
        </p>
        <p>
            GENERAL
        </p>
        <p>
            Force Majeure. SOFOS will not be deemed in default hereunder or held
            responsible for any cessation, interruption or delay in the
            performance of its obligations hereunder due to earthquake, flood,
            fire, storm, natural disaster, act of God, war, terrorism, armed
            conflict, labor strike, lockout, or boycott.
        </p>
        <p>
            Cessation of Operation. SOFOS may at any time, in its sole
            discretion and without advance notice to you, cease operation of the
            Website and distribution of the Services.
        </p>
        <p>
            Entire Agreement. This Agreement comprises the entire agreement
            between you and SOFOS and supersedes any prior agreements pertaining
            to the subject matter contained herein.
        </p>
        <p>
            Effect of Waiver. The failure of SOFOS to exercise or enforce any
            right or provision of this Agreement will not constitute a waiver of
            such right or provision. If any provision of this Agreement is found
            by a court of competent jurisdiction to be invalid, the parties
            nevertheless agree that the court should endeavor to give effect to
            the parties' intentions as reflected in the provision, and the other
            provisions of this Agreement remain in full force and effect.
        </p>
        <p>
            Governing Law; Jurisdiction: This Website originates from the city
            of Pune, Maharashtra State, Country: India. This Agreement will be
            governed by the laws of India and the courts in Pune will have
            exclusive jurisdiction to try any dispute arising from the use of
            this website. By using this Website or ordering Services, you
            consent to the jurisdiction and venue of such courts in connection
            with any action, suit, proceeding or claim arising under or by
            reason of this Agreement.
        </p>
        <p>
            Statute of Limitation. You agree that regardless of any statute or
            law to the contrary, any claim or cause of action arising out of or
            related to use of the Website or Services or this Agreement must be
            filed within one (1) year after such claim or cause of action arose
            or be forever barred.
        </p>
        <p>
            Waiver of Class Action Rights. BY ENTERING INTO THIS AGREEMENT, YOU
            HEREBY IRREVOCABLY WAIVE ANY RIGHT YOU MAY HAVE TO JOIN CLAIMS WITH
            THOSE OF OTHER IN THE FORM OF CLASS ACTION OR SIMILAR PROCEDURAL
            DEVICE. ANY CLAIMS ARISING OUT OF, RELATING TO, OR CONNECTION WITH
            THIS AGREEMENT MUST BE ASSERTED INDIVIDUALLY.
        </p>
        <p>
            Termination: SOFOS reserves the right to terminate your access to
            the Website if it reasonably believes, in its sole discretion, that
            you have breached any of the terms and conditions of this Agreement.
            Following termination, you will not be permitted to use the Website
            and SOFOS may, in its sole discretion and without advance notice to
            you, cancel any outstanding orders for Services. If your access to
            the Website is terminated, SOFOS reserves the right to exercise
            whatever means it deems necessary to prevent unauthorized access of
            the Website. This Agreement will survive indefinitely unless and
            until SOFOS chooses, in its sole discretion and without advance to
            you, to terminate it.
        </p>
        <p>
            Domestic Use: SOFOS makes no representation that the Website or
            Services are appropriate or available for use in locations outside
            India. Users who access the Website from outside India do so at
            their own risk and initiative and must bear all responsibility for
            compliance with any applicable local laws.
        </p>
        <p>
            Assignment: You may not assign your rights and obligations under
            this Agreement to anyone. SOFOS may assign its rights and
            obligations under this Agreement in its sole discretion and without
            advance notice to you.
        </p>
        <p>
            Website Disclaimer: The information contained in this website is for
            general information purposes only. The information is provided by
            Eduracle, a property of Sofos Learning Solutions Private Limited.
            While we endeavour to keep the information up to date and correct,
            we make no representations or warranties of any kind, express or
            implied, about the completeness, accuracy, reliability, suitability
            or availability with respect to the website or the information,
            products, services, or related graphics contained on the website for
            any purpose. Any reliance you place on such information is therefore
            strictly at your own risk. In no event will we be liable for any
            loss or damage including without limitation, indirect or
            consequential loss or damage, or any loss or damage whatsoever
            arising from loss of data or profits arising out of, or in
            connection with, the use of this website. The inclusion of any links
            does not necessarily imply a recommendation or endorse the views
            expressed within them. Every effort is made to keep the website up
            and running smoothly. However, Sofos Learning Solutions Private
            Limited takes no responsibility for, and will not be liable for, the
            website being temporarily unavailable due to technical issues beyond
            our control.
        </p>
        <p>
            BY USING THIS WEBSITE OR ORDERING SERVICES FROM THIS WEBSITE YOU
            AGREE TO BE BOUND BY ALL OF THE TERMS AND CONDITIONS OF THIS
            AGREEMENT.
        </p>
    </div>
    </v-col>
    </v-row>
    </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
    name: "Terms-and-condtions",
    mounted() {},
    data() {
        return {};
    },

    methods: {},
};
</script>
